import React from 'react';
import { useSession, useAPIRequest } from 'core';
import { LoadingContainer, Alert } from 'ffsdk';
import { Invoice } from 'types';
import { Link } from 'react-router-dom';
import { addDays, formatISO } from 'date-fns';
import { formatDate } from 'core/util';
const deadline = formatISO(addDays(new Date(), 10), { representation: 'date' });

function Card(): React.ReactElement {
  const invoices = useAPIRequest<Invoice[]>({
    url: 'invoicing/invoices/',
    method: 'GET',
    queryParams: {
      not_checked_out: true,
      page_size: '',
      checkout_before: deadline,
      ordering: 'checkout_date',
    },
  });

  const rows = invoices || [];
  return (
    <div className="card">
      <div className="card-body">
        <h5 className="card-title">Tuvojas rēķina izrakstīšanas datums</h5>
        <LoadingContainer loading={!invoices}>
          {rows.length > 0 ? (
            <table className="table table-sm mb-0">
              <thead>
                <tr>
                  <th>Numurs</th>
                  <th>Klients</th>
                  <th>Izr. dat.</th>
                  <th className="text-right">Summa</th>
                </tr>
              </thead>
              <tbody>
                {rows.map(({ id, display_number, client, checkout_date, sum_total }) => (
                  <tr key={id}>
                    <td>
                      <Link to={`/campaigns/invoices/${id}`}>{display_number}</Link>
                    </td>
                    <td>{client.title}</td>
                    <td>{formatDate(checkout_date)}</td>
                    <td className="text-right">{sum_total}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <Alert variant="success" className="mb-0">
              Visi rēķini izrakstīti
            </Alert>
          )}
        </LoadingContainer>
      </div>
    </div>
  );
}
export function ApproachingInvoices(): React.ReactElement | null {
  const { hasPerm } = useSession();
  const viewApproachingInvoices = hasPerm('invoicing.view_approaching_invoices');
  if (!viewApproachingInvoices) {
    return null;
  }
  return <Card />;
}
